export default __webpack_public_path__ + "static/media/img-slider-om-wallet-1.afa3b233.png";